exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#print-article-modal .modal-dialog{max-width:350px}", ""]);

